import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

export interface DeleteTrackableItemsParams {
  trackable_list_id: string;
  trackable_item_ids: string[];
}

export function useDeleteTrackableItems({
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, DeleteTrackableItemsParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ trackable_list_id, trackable_item_ids }: DeleteTrackableItemsParams) => {
      await client.delete(`/apps/${applicationID}/trackables/${trackable_list_id}/items`, {
        params: { 'trackable_item_ids[]': trackable_item_ids },
      });
    },
    {
      ...options,
      onSettled: (...args) => {
        onSettled?.(...args);

        // Invalidate trackable items queries
        queryClient.invalidateQueries(['trackable-items']);
      },
    }
  );
}